<div class="row">
  <div class="col-12" style="height: 71vh !important; overflow: auto;"> 
<form [formGroup]="ResourceAssignform">
    

  <div class="col-12">
    <div class="row pt-3">
      <div class="col-3 text-right pr-0 pt-1">        
        <div class="d-flex  flex-row-reverse">
         <div class="p-0 label-red">*</div>
      <div class="p-0">Role Type</div></div> </div>
      <div class="col-9 pl-2" *ngIf="!EditResourcePopup">
        <select class="form-control input-txt"  (change)="ResourceName1($event)" (ngModelChange)="Editformvalidation()" formControlName="PowerUserRoleTypeCode" id="selectPowerUserID">
          
            <option class="border-bottom" *ngFor="let s of getcodes;let i=index"  [value]="s.Code">{{s.Code}}</option>
        </select> 
      </div>
      <div class="col-9 pl-2" *ngIf="EditResourcePopup">
        <select class="form-control input-txt"  (change)="ResourceName1($event)" (ngModelChange)="Editformvalidation()" formControlName="PowerUserRoleTypeCode"  id="selectPowerUser_ID">
         
            <option class="border-bottom" disabled *ngFor="let s of getcodes;let i=index"  [value]="s.Code">{{s.Code}}</option>
        </select> 
      </div>
      <div class="col-3"></div>
      <div class="col-9"><label  class="Valid1"  *ngIf="save_submitted && !ResourceAssignform.value.PowerUserRoleTypeCode">Please Choose Role Type</label></div>
    </div>
  </div>
  <div class="col-12">
    <div class="row pt-2">
      <div class="col-3 text-right pr-0 pt-1">        
        <div class="d-flex  flex-row-reverse">
         <div class="p-0 label-red">*</div>
      <div class="p-0">Resource Name</div></div> </div>
      <div class="col-9 pl-2">
        <select  formControlName="PowerUserId"  class="form-control input-txt" (ngModelChange)="Editformvalidation()">
          
        <option class="border-bottom" *ngFor="let s of getresourcedetails;let i=index" [value]="s.Power_User_ID">{{s.Full_Name}}</option>
      </select> 
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="row pt-2">
      <div class="col-3 text-right pr-0 pt-1">        
        <div class="d-flex  flex-row-reverse">
         <div class="p-0 label-red">*</div>
      <div class="p-0">Start date</div></div> </div>
      <div class="col-9 pl-2">
        <input type="text" formControlName="StartDate"  [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1"
       class="form-control input-txt txtInput" (click)="compareStartDates()" (click)="compareStartDates()" (ngModelChange)="compareStartDates()">
       <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
      </div>
      <div class="col-3"></div>
      <div class="col-9"><label  class="Valid1"  *ngIf="error1.isError">{{error1.errorMessage}}</label>
      </div>
      <div class="col-3"></div>
      <div class="col-9"><label  class="Valid1"  *ngIf="save_submitted && !ResourceAssignform.value.StartDate">Please Select Start Date</label></div>
    </div>
  
  </div>
  <div class="col-12">
    <div class="row pt-2">
      <div class="col-3 text-right pr-0 pt-1">        
        <div class="d-flex  flex-row-reverse">
      <div class="p-0">End date</div></div> </div>
      <div class="col-9 pl-2">
        <input type="text"  formControlName="EndDate" [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2"
        class="form-control input-txt txtInput" (click)="compareEndDates()" (change)="compareEndDates()" (ngModelChange)="compareEndDates()">
      <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
      </div>
      <div class="col-3"></div>
      <div class="col-9"><label  class="Valid1" *ngIf="error.isError">{{error.errorMessage}}</label></div>
    </div>
  </div>
  <div class="col-12">
    <div class="row pt-2">
      <div class="col-3 text-right pr-0 pt-1">        
        <div class="d-flex  flex-row-reverse">
          <div class="p-0 label-red">*</div>
      <div class="p-0">Assignment Status</div></div> </div>
      <div class="col-9 pl-2">
        <select formControlName="RoleAssignmentStatusTypeCode" (ngModelChange)="Editformvalidation()" class="form-control input-txt">
          <option class="border-bottom" *ngFor="let s of getAssignmentstatus" [value]="s.Code">{{s.Code}}</option>
       </select>
      </div>
    </div>
  </div>
  <div class="col-12 text-right">
    <div class="row pt-2">
      <div class="col-3 text-right pr-0 pt-1 pl-0">        
        <div class="d-flex  flex-row-reverse">
      <div class="p-0">Assignment Intructions</div></div> </div>
      <div class="col-6 pl-2">
        <textarea formControlName="AssignmentCommentText" (ngModelChange)="Editformvalidation()" maxlength="4000" class="form-control input-txt1" id="txtAssignmentIntruction"></textarea>
        <label class="form-check-label maxlength " for="exampleCheck1">Characters {{Descriptionvaluelength}}/{{DescriptionMaxlength}}</label>
      </div>
      <div class="col-3 pr-0 pt-1 pl-0"></div>
      
    </div>
  </div>

</form>
</div>
</div>

